var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBadge)?_c('div',{staticClass:"cluster-badge",style:({ backgroundColor: _vm.cluster.badge.color, color: _vm.cluster.badge.textColor })},[_vm._v("\n  "+_vm._s(_vm.cluster.badge.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }